<div class="header header-menu qm-bg-primary-linear-gradient">
  <div class="container">
    <!-- after login menu -->
    @if (loginService.isLogin()) {
      <nav class="navbar navbar-expand-lg px-0 py-4 align-items-end justify-content-between">
        <div class="col-auto mw-100">
          <a
            [routerLink]="['/home']"
            class="navbar-brand"
            (click)="loginService.doGoogleTracking('InternalAdminPortal', 'NavMenu', 'go to home')"
          >
            <img width="500" src="../../../assets/images/qm-logos/Quotemonster-IAP-Logo.png?v=2" alt="qm-logo" />
          </a>
        </div>
        <div class="col text-end mt-3">
          @if (adminUserMenuGroup?.length > 0) {
            <button mat-button class="qm-text-btn-white me-3 scale-120" [matMenuTriggerFor]="menu">
              <span class="material-icons">menu</span>
            </button>
          }
          <mat-menu #menu="matMenu">
            <a
              mat-menu-item
              [routerLink]="['/home']"
              (click)="loginService.doGoogleTracking('InternalAdminPortal', 'NavMenu', 'go to home')"
            >
              <span class="material-icons me-1">home</span>
              Home
            </a>
            @if (adminUserMenuGroup?.length > 0) {
              @for (group of adminUserMenuGroup; track group.Code) {
                <h6 class="mx-3 mb-0 text-black-50">{{ group.GroupName }}</h6>
                <mat-divider />
                @for (menu of group.Items; track menu) {
                  @if (menu.DevModeOnly == false || menu.DevModeOnly == isDevMode) {
                    <a
                      mat-menu-item
                      [routerLink]="[menu.ItemLink]"
                      (click)="loginService.doGoogleTracking('InternalAdminPortal', 'NavMenu', menu.TrackingName)"
                    >
                      <span class="material-icons mx-3"></span>
                      {{ menu.ItemName }}
                    </a>
                  }
                }
              }
            }
          </mat-menu>
          <button
            mat-button
            class="qm-text-btn-white scale-120 text-nowrap flex-row-reverse"
            aria-label="logout"
            (click)="logout(); loginService.doGoogleTracking('InternalAdminPortal', 'NavMenu', 'logout')"
            title="logout"
          >
            <span class="me-2 text-transform-none">{{ userDetail.FirstName }}</span>
            <span class="material-icons">logout</span>
          </button>
        </div>
      </nav>
    }

    <!--before login menu-->
    @if (loginService.isLogin() === false) {
      <nav class="navbar navbar-expand-lg px-0 py-4 align-items-end">
        <a [routerLink]="['/login']" class="navbar-brand">
          <img width="500" src="./../../assets/images/qm-logos/Quotemonster-IAP-Logo.png?v=2" alt="qm-logo" />
        </a>
      </nav>
    }
  </div>
</div>
